import { apiRequest } from '@/lib/api-client';
import type { CreatorProfile } from '@/store/authStore';

export interface UpdateProfileData {
  full_name?: string;
  display_name?: string | null;
  creator_type?: string | null;
  location?: string | null;
  pronouns?: string | null;
  bio?: string | null;
  profile_photo_url?: string | null;
  timezone?: string;
  onboarding_completed?: boolean;
  initial_setup_completed?: boolean;
  // Setting `email` does NOT change the live email — it sets pending_email
  // and triggers a verification send to the new address.
  email?: string;
}

export interface ExportRequestResponse {
  message: string;
  export_id: string;
}

export function getProfile(): Promise<CreatorProfile> {
  return apiRequest<CreatorProfile>('/api/profile');
}

export function updateProfile(data: UpdateProfileData): Promise<CreatorProfile> {
  return apiRequest<CreatorProfile>('/api/profile', {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export function deleteAccount(): Promise<{ message: string }> {
  return apiRequest<{ message: string }>('/api/profile', {
    method: 'DELETE',
  });
}

export function requestExport(): Promise<ExportRequestResponse> {
  return apiRequest<ExportRequestResponse>('/api/profile/export');
}
